import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskEndTodayRPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskEndTodayRPage;
